module.exports = __webpack_public_path__ + "static/media/blackops6.c000fc38.webp";